import { render, staticRenderFns } from "./SidebarAddUser.vue?vue&type=template&id=568aeee2"
import script from "./SidebarAddUser.vue?vue&type=script&lang=js"
export * from "./SidebarAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports